module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/glow-top.816616bd.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/glow-top.png
// module id = 2837
// module chunks = 11